import React from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  return (
     <ul>
      <li><Link to="/week5-assignment">Home</Link></li>
    </ul>
  );
}
